// Complete Translation files for multi-language support
export const translations = {
  ar: {
    // General
    appName: 'مدير المخبز',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    search: 'بحث',
    loading: 'جاري التحميل...',
    noData: 'لا يوجد بيانات',
    error: 'حدث خطأ',
    success: 'تم بنجاح',
    confirm: 'تأكيد',
    print: 'طباعة',
    export: 'تصدير',
    close: 'إغلاق',
    yes: 'نعم',
    no: 'لا',
    actions: 'إجراءات',
    details: 'التفاصيل',
    total: 'الإجمالي',
    currency: '€',
    
    // Navigation
    dashboard: 'لوحة التحكم',
    customers: 'الزبائن',
    orders: 'الطلبات',
    products: 'المنتجات',
    delivery: 'ورقة التوصيل',
    reports: 'التقارير',
    expenses: 'المصروفات',
    drivers: 'السائقين',
    settings: 'الإعدادات',
    more: 'المزيد',
    staffUsers: 'إدارة المستخدمين',
    auditLogs: 'سجل التدقيق',
    attendanceReport: 'تقرير الدوام',
    financialDues: 'المستحقات المالية',
    financials: 'المالية',
    financialsDesc: 'إدارة المستحقات والمصروفات',
    finance: 'المالية',
    profitReport: 'تقرير الأرباح',
    employees: 'الموظفين',
    withdrawals: 'المسحوبات',
    whatsappMessages: 'رسائل واتساب',
    germanInvoices: 'الفواتير الألمانية',
    invoices: 'الفواتير القديمة',
    deliveryProofs: 'إثبات الاستلام',
    communication: 'التواصل',
    production: 'كمية الإنتاج',
    whatsappConnect: 'ربط واتساب',
    announcements: 'الإعلانات',
    
    // Login Page
    loginTitle: 'تسجيل الدخول',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    enterUsername: 'أدخل اسم المستخدم',
    enterPassword: 'أدخل كلمة المرور',
    loginButton: 'دخول',
    freeTrial: 'تجربة مجانية!',
    freeTrialDesc: 'تسجيل الدخول للتجربة مجاني ليوم واحد',
    noAccount: 'ليس لديك حساب؟',
    contactAdmin: 'اتصل بالمدير للحصول على بيانات الدخول',
    contactViaWhatsapp: 'تواصل عبر واتساب',
    dataSecure: 'جميع البيانات سرية ومحمية بالكامل',
    wrongCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    
    // Dashboard
    todayOrders: 'طلبات اليوم',
    todayRevenue: 'إيرادات اليوم',
    totalCustomers: 'عدد الزبائن',
    weeklyOrders: 'طلبات الأسبوع',
    totalRevenue: 'إجمالي الإيرادات',
    pendingDelivery: 'بانتظار التوصيل',
    welcome: 'مرحباً',
    dashboardDesc: 'نظرة عامة على أداء مخبزك',
    recentOrders: 'أحدث الطلبات',
    topCustomers: 'أفضل الزبائن',
    
    // Customers
    customerName: 'اسم الزبون',
    shopName: 'اسم المحل',
    phone: 'الهاتف',
    whatsappPhone: 'رقم الواتساب',
    address: 'العنوان',
    area: 'المنطقة',
    deliveryOrder: 'ترتيب التوصيل',
    totalDebt: 'إجمالي المستحق',
    totalPaid: 'إجمالي المدفوع',
    balance: 'الرصيد المتبقي',
    addCustomer: 'إضافة زبون',
    editCustomer: 'تعديل زبون',
    customerPrices: 'أسعار الزبون',
    taxRate: 'نسبة الضريبة',
    customerStatement: 'كشف الحساب',
    noCustomers: 'لا يوجد زبائن',
    addFirstCustomer: 'أضف أول زبون للبدء',
    searchCustomers: 'بحث عن زبون...',
    customerCount: 'زبون',
    deleteCustomerConfirm: 'هل أنت متأكد من حذف هذا الزبون؟',
    deleteCustomerWarning: 'سيتم حذف الزبون وجميع طلباته ومدفوعاته',
    customerDeleted: 'تم حذف الزبون',
    customerAdded: 'تم إضافة الزبون',
    customerUpdated: 'تم تحديث الزبون',
    deliveryOrderHint: 'رقم ترتيب التوصيل (للسائق)',
    noSearchResults: 'لا يوجد نتائج للبحث',
    paymentType: 'نوع الدفع',
    fullPayment: 'دفع كامل',
    partialPayment: 'دفع جزئي',
    credit: 'آجل',
    optionalNotes: 'ملاحظات اختيارية...',
    loadError: 'حدث خطأ في تحميل البيانات',
    saveError: 'حدث خطأ في الحفظ',
    deleteError: 'حدث خطأ في الحذف',
    paymentRecorded: 'تم تسجيل الدفعة بنجاح',
    paymentError: 'حدث خطأ في حفظ الدفعة',
    openingBalanceUpdated: 'تم تحديث الرصيد الافتتاحي بنجاح',
    openingBalanceError: 'حدث خطأ في تحديث الرصيد',
    remainingBalance: 'الرصيد المتبقي',
    optionalNotes: 'ملاحظات اختيارية...',
    bundle: 'ربطة',
    pricingType: 'طريقة الحساب',
    byBox: 'بالصندوق',
    byPiece: 'بالقطعة',
    totalPieces: 'إجمالي القطع',
    
    // Orders
    date: 'التاريخ',
    day: 'اليوم',
    quantity: 'الكمية',
    price: 'السعر',
    notes: 'ملاحظات',
    addOrder: 'إضافة طلب',
    editOrder: 'تعديل طلب',
    selectCustomer: 'اختر الزبون',
    noOrders: 'لا يوجد طلبات',
    noOrdersForDate: 'لا يوجد طلبات لهذا اليوم',
    orderAdded: 'تم إضافة الطلب',
    orderUpdated: 'تم تحديث الطلب',
    orderDeleted: 'تم حذف الطلب',
    orderCount: 'طلب',
    todayDate: 'تاريخ اليوم',
    enterQuantity: 'الرجاء إدخال كمية واحدة على الأقل',
    orderExistsError: 'يوجد طلب مسبق لهذا الزبون في هذا التاريخ',
    customerBalance: 'رصيد الزبون',
    customerHasBalance: 'الزبون عليه مبلغ متبقي',
    accountSettled: 'الحساب مسدد بالكامل',
    amountToCollect: 'مبلغ للاستلام من الزبون',
    amountToCollectHint: 'سيظهر للسائق في ورقة التوصيل',
    deleteOrderConfirm: 'هل أنت متأكد من حذف هذا الطلب؟',
    deleteOrderWarning: 'سيتم حذف طلب',
    cannotUndo: 'هذا الإجراء لا يمكن التراجع عنه',
    box: 'صندوق',
    
    // Products
    productName: 'اسم المنتج',
    breadsPerBox: 'عدد الربطات',
    defaultPrice: 'سعر البيع',
    costPrice: 'سعر الشراء',
    profit: 'الربح',
    addProduct: 'إضافة منتج',
    editProduct: 'تعديل منتج',
    bigBox: 'صندوق كبير',
    smallBread: 'خبز صغير',
    brownBread: 'خبز أسمر',
    noProducts: 'لا يوجد منتجات',
    productAdded: 'تم إضافة المنتج',
    productUpdated: 'تم تحديث المنتج',
    productDeleted: 'تم حذف المنتج',
    productCount: 'منتج',
    
    // Delivery
    deliverySheet: 'ورقة التوصيل',
    totalBoxes: 'إجمالي الصناديق',
    boxesToReturn: 'صناديق للإرجاع',
    boxesReturned: 'صناديق مُرجعة',
    noDeliveries: 'لا يوجد طلبات للتوصيل',
    printDelivery: 'طباعة الورقة',
    deliveryCount: 'توصيل',
    updateBoxes: 'تحديث الصناديق',
    boxesUpdated: 'تم تحديث الصناديق',
    returnedBoxes: 'الصناديق المرتجعة',
    expectedBoxes: 'الصناديق المتوقعة',
    difference: 'الفرق',
    
    // Reports
    weeklyReport: 'التقرير الأسبوعي',
    fromDate: 'من',
    toDate: 'إلى',
    thisWeek: 'هذا الأسبوع',
    lastWeek: 'الأسبوع الماضي',
    generateReport: 'إنشاء التقرير',
    totalSales: 'إجمالي المبيعات',
    totalExpenses: 'إجمالي المصروفات',
    netProfit: 'صافي الربح',
    remaining: 'المتبقي',
    paid: 'المدفوع',
    selectPeriod: 'اختر الفترة الزمنية',
    reportGenerated: 'تم إنشاء التقرير',
    exportCSV: 'تصدير CSV',
    customerDetails: 'تفاصيل الزبائن',
    
    // Expenses
    expenseCategory: 'فئة المصروف',
    amount: 'المبلغ',
    diesel: 'ديزل',
    maintenance: 'صيانة',
    salary: 'راتب',
    other: 'أخرى',
    addExpense: 'إضافة مصروف',
    editExpense: 'تعديل مصروف',
    noExpenses: 'لا يوجد مصروفات',
    expenseAdded: 'تم إضافة المصروف',
    expenseDeleted: 'تم حذف المصروف',
    expenseCount: 'مصروف',
    description: 'الوصف',
    
    // Drivers
    driverName: 'اسم السائق',
    addDriver: 'إضافة سائق',
    noDrivers: 'لا يوجد سائقين',
    driverAdded: 'تم إضافة السائق',
    driverDeleted: 'تم حذف السائق',
    driverPassword: 'كلمة مرور السائق',
    driverCount: 'سائق',
    
    // Settings
    companyInfo: 'معلومات الشركة',
    companyName: 'اسم الشركة',
    ownerName: 'اسم المالك',
    taxNumber: 'الرقم الضريبي',
    logo: 'الشعار',
    bakeryManagement: 'إدارة المخابز',
    addBakery: 'إضافة مخبز',
    superAdminNote: 'أنت المدير الرئيسي - فقط أنت تستطيع إنشاء وحذف حسابات المخابز',
    settingsSaved: 'تم حفظ الإعدادات',
    uploadLogo: 'رفع الشعار',
    logoHint: 'الحد الأقصى 500KB - يُفضل صورة مربعة',
    bakeryAdded: 'تم إضافة المخبز',
    bakeryDeleted: 'تم حذف المخبز',
    copyCredentials: 'نسخ بيانات الدخول',
    credentialsCopied: 'تم نسخ البيانات',
    noBakeries: 'لا يوجد مخابز مسجلة',
    
    // Payments
    addPayment: 'إضافة دفعة',
    paymentType: 'نوع الدفعة',
    fullPayment: 'دفعة كاملة',
    partialPayment: 'دفعة جزئية',
    credit: 'آجل',
    paymentAdded: 'تم إضافة الدفعة',
    paymentDeleted: 'تم حذف الدفعة',
    editPayment: 'تعديل الدفعة',
    paymentUpdated: 'تم تعديل الدفعة',
    deletePaymentConfirm: 'هل تريد حذف هذه الدفعة؟',
    
    // Production
    production: 'كمية الإنتاج',
    dailyProduction: 'الإنتاج اليومي',
    productionQuantity: 'كمية الإنتاج',
    produced: 'المنتَج',
    saveProduction: 'حفظ الإنتاج',
    productionSaved: 'تم حفظ كمية الإنتاج',
    noProducts: 'لا توجد منتجات',
    productionReport: 'تقرير الإنتاج',
    productionSummaryTitle: 'ملخص الإنتاج',
    dailyProductionDetail: 'تفاصيل الإنتاج اليومي',
    customerSalesReport: 'المبيعات والتسليمات والمبالغ حسب الزبون',
    totalSales: 'إجمالي المبيعات',
    totalReceived: 'إجمالي المستلم',
    totalOutstanding: 'المبالغ المستحقة',
    sold: 'المباع',
    remaining: 'المتبقي',
    outstanding: 'المستحق',
    paid: 'المدفوع',
    delivered: 'تم التسليم',
    pending: 'معلّق',
    partialDelivery: 'توصيل جزئي',
    fullDelivery: 'تسليم كامل',
    deliveredQuantities: 'الكميات المسلمة',
    todaySales: 'مبيعات اليوم',
    deliveryStatus: 'حالة التسليم',
    financialSummary: 'الملخص المالي',
    todayPayments: 'مدفوعات اليوم',
    noProductionToday: 'لم يتم تسجيل إنتاج اليوم',
    customersCount: 'عدد الزبائن',
    bundle: 'ربطة',
    bundles: 'ربطات',
    bundlesSold: 'ربطات مباعة',
    totalSold: 'إجمالي المباع',
    daily: 'يومي',
    weekly: 'أسبوعي',
    monthly: 'شهري',
    monthlyReport: 'التقرير الشهري',
    
    // Invoices
    invoices: 'الفواتير',
    germanInvoices: 'الفواتير الألمانية',
    newInvoice: 'فاتورة جديدة',
    createInvoice: 'إنشاء فاتورة',
    invoiceCreated: 'تم إنشاء الفاتورة',
    noInvoices: 'لا توجد فواتير',
    backToInvoices: 'رجوع للفواتير',
    taxRate: 'نسبة الضريبة',
    taxFree: 'بدون ضريبة',
    deleteInvoiceConfirm: 'هل تريد حذف هذه الفاتورة؟',
    selectCustomer: 'اختر زبون',
    enterCustomerName: 'أدخل اسم الزبون',
    enterProductName: 'أدخل اسم المنتج',
    
    // Statement
    copyAsImage: 'نسخ كصورة',
    downloadImage: 'تحميل صورة',
    imageCopied: 'تم نسخ الصورة',
    statementPeriod: 'فترة الكشف',
    ordersSummary: 'ملخص الطلبات',
    paymentsSummary: 'ملخص المدفوعات',
    accountStatement: 'كشف حساب',
    backToCustomers: 'العودة للزبائن',
    backButton: 'العودة',
    dataNotFound: 'لم يتم العثور على البيانات',
    from: 'من',
    to: 'إلى',
    previousBalance: 'رصيد سابق',
    before: 'قبل',
    ordersTitle: 'الطلبات',
    dateColumn: 'التاريخ',
    dayColumn: 'اليوم',
    productsColumn: 'المنتجات',
    amountColumn: 'المبلغ',
    taxColumn: 'الضريبة',
    totalColumn: 'الإجمالي',
    totalBoxes: 'إجمالي الصناديق',
    paymentsTitle: 'المدفوعات',
    typeColumn: 'النوع',
    notesColumn: 'ملاحظات',
    totalSalesLabel: 'إجمالي المبيعات',
    taxLabel: 'الضريبة',
    paidLabel: 'المدفوع',
    remainingBalance: 'الرصيد المتبقي',
    statementCreated: 'تم إنشاء هذا الكشف بتاريخ',
    copyImageSuccess: 'تم نسخ الصورة - يمكنك لصقها في واتساب',
    imageDownloaded: 'تم تحميل الصورة',
    copyImageError: 'حدث خطأ في إنشاء الصورة',
    creatingImage: 'جاري إنشاء الصورة...',
    phoneLabel: 'هاتف',
    taxNumberLabel: 'الرقم الضريبي',
    bakery: 'المخبز',
    
    // Days
    sunday: 'الأحد',
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    
    // Driver Page
    driverView: 'واجهة السائق',
    driverWelcome: 'مرحباً بك',
    todayDeliveries: 'توصيلات اليوم',
    selectDate: 'اختر التاريخ',
    refreshList: 'تحديث القائمة',
    markDelivered: 'تم التسليم',
    enterBoxesReturned: 'أدخل عدد الصناديق المرتجعة',
    boxesExpected: 'العدد المتوقع',
    confirmBoxes: 'تأكيد',
    deliveryNotes: 'ملاحظات التوصيل',
    customerAddress: 'عنوان الزبون',
    itemsToDeliver: 'المنتجات للتوصيل',
    
    // New Driver Features
    confirmDelivery: 'تأكيد التوصيل',
    deliveryStatus: 'حالة التسليم',
    fullDelivery: 'تسليم كامل',
    partialDelivery: 'تسليم جزئي',
    deliveredQuantities: 'الكميات المسلمة',
    amountToCollect: 'مبلغ للاستلام',
    amountCollected: 'المبلغ المستلم',
    toCollect: 'للاستلام',
    collected: 'تم استلام',
    expected: 'المتوقع',
    optionalNotes: 'ملاحظات اختيارية...',
    delivered: 'تم التسليم',
    pending: 'في الانتظار',
    status: 'الحالة',
    deliveryConfirmed: 'تم تأكيد التوصيل بنجاح',
    
    // Proof of Delivery
    proofOfDelivery: 'إثبات الاستلام',
    deliveryProofs: 'إثبات الاستلام',
    deliveryProofsDescription: 'صور إثبات تسليم البضائع للزبائن',
    uploadPhoto: 'رفع صورة',
    clickToUpload: 'اضغط لرفع صورة',
    selectPhoto: 'الرجاء اختيار صورة',
    uploadProof: 'رفع الإثبات',
    proofUploaded: 'تم رفع إثبات الاستلام بنجاح',
    uploadError: 'خطأ في رفع الصورة',
    noProofs: 'لا توجد إثباتات',
    noProofsDescription: 'لم يتم رفع أي صور إثبات استلام بعد',
    viewImage: 'عرض الصورة',
    remove: 'حذف',
    clearFilters: 'مسح الفلترة',
    allCustomers: 'جميع الزبائن',
    customer: 'الزبون',
    
    // Errors & Messages
    loadError: 'حدث خطأ في تحميل البيانات',
    saveError: 'حدث خطأ في حفظ البيانات',
    deleteError: 'حدث خطأ في الحذف',
    networkError: 'خطأ في الاتصال',
    tryAgain: 'حاول مرة أخرى',
  },
  
  de: {
    // General
    appName: 'Bäckerei Manager',
    login: 'Anmelden',
    logout: 'Abmelden',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    search: 'Suchen',
    loading: 'Laden...',
    noData: 'Keine Daten',
    error: 'Fehler aufgetreten',
    success: 'Erfolgreich',
    confirm: 'Bestätigen',
    print: 'Drucken',
    export: 'Exportieren',
    close: 'Schließen',
    yes: 'Ja',
    no: 'Nein',
    actions: 'Aktionen',
    details: 'Details',
    total: 'Gesamt',
    currency: '€',
    
    // Navigation
    dashboard: 'Dashboard',
    customers: 'Kunden',
    orders: 'Bestellungen',
    products: 'Produkte',
    delivery: 'Lieferschein',
    reports: 'Berichte',
    expenses: 'Ausgaben',
    drivers: 'Fahrer',
    settings: 'Einstellungen',
    more: 'Mehr',
    staffUsers: 'Benutzerverwaltung',
    attendanceReport: 'Anwesenheitsbericht',
    financialDues: 'Finanzielle Forderungen',
    financials: 'Finanzen',
    financialsDesc: 'Forderungen und Ausgaben verwalten',
    profitReport: 'Gewinnbericht',
    employees: 'Mitarbeiter',
    withdrawals: 'Abhebungen',
    whatsappMessages: 'WhatsApp Nachrichten',
    germanInvoices: 'Deutsche Rechnungen',
    invoices: 'Alte Rechnungen',
    deliveryProofs: 'Liefernachweis',
    
    // Login Page
    loginTitle: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    enterUsername: 'Benutzername eingeben',
    enterPassword: 'Passwort eingeben',
    loginButton: 'Einloggen',
    freeTrial: 'Kostenlose Testversion!',
    freeTrialDesc: 'Anmeldung für einen Tag kostenlos testen',
    noAccount: 'Kein Konto?',
    contactAdmin: 'Kontaktieren Sie den Administrator',
    contactViaWhatsapp: 'Über WhatsApp kontaktieren',
    dataSecure: 'Alle Daten sind vertraulich und geschützt',
    wrongCredentials: 'Falscher Benutzername oder Passwort',
    
    // Dashboard
    todayOrders: 'Heutige Bestellungen',
    todayRevenue: 'Heutiger Umsatz',
    totalCustomers: 'Anzahl Kunden',
    weeklyOrders: 'Wöchentliche Bestellungen',
    totalRevenue: 'Gesamtumsatz',
    pendingDelivery: 'Ausstehende Lieferung',
    welcome: 'Willkommen',
    dashboardDesc: 'Übersicht über Ihre Bäckerei',
    recentOrders: 'Neueste Bestellungen',
    topCustomers: 'Top Kunden',
    
    // Customers
    customerName: 'Kundenname',
    shopName: 'Geschäftsname',
    phone: 'Telefon',
    address: 'Adresse',
    area: 'Gebiet',
    deliveryOrder: 'Lieferreihenfolge',
    totalDebt: 'Gesamtschuld',
    totalPaid: 'Gesamt bezahlt',
    balance: 'Restbetrag',
    addCustomer: 'Kunde hinzufügen',
    editCustomer: 'Kunde bearbeiten',
    customerPrices: 'Kundenpreise',
    taxRate: 'Steuersatz',
    customerStatement: 'Kontoauszug',
    noCustomers: 'Keine Kunden',
    addFirstCustomer: 'Fügen Sie den ersten Kunden hinzu',
    searchCustomers: 'Kunde suchen...',
    customerCount: 'Kunde',
    deleteCustomerConfirm: 'Kunde wirklich löschen?',
    customerDeleted: 'Kunde gelöscht',
    customerAdded: 'Kunde hinzugefügt',
    customerUpdated: 'Kunde aktualisiert',
    deliveryOrderHint: 'Lieferreihenfolge-Nummer',
    noSearchResults: 'Keine Ergebnisse',
    paymentType: 'Zahlungsart',
    fullPayment: 'Vollständige Zahlung',
    partialPayment: 'Teilzahlung',
    optionalNotes: 'Optionale Notizen...',
    loadError: 'Fehler beim Laden',
    saveError: 'Fehler beim Speichern',
    deleteError: 'Fehler beim Löschen',
    deleteCustomerWarning: 'Kunde und alle Daten werden gelöscht',
    pricingType: 'Preisberechnungsart',
    byBox: 'Pro Kiste',
    byPiece: 'Pro Stück',
    totalPieces: 'Gesamt Stück',
    
    // Orders
    date: 'Datum',
    day: 'Tag',
    quantity: 'Menge',
    price: 'Preis',
    notes: 'Notizen',
    addOrder: 'Bestellung hinzufügen',
    editOrder: 'Bestellung bearbeiten',
    selectCustomer: 'Kunde auswählen',
    noOrders: 'Keine Bestellungen',
    noOrdersForDate: 'Keine Bestellungen für diesen Tag',
    orderAdded: 'Bestellung hinzugefügt',
    orderUpdated: 'Bestellung aktualisiert',
    orderDeleted: 'Bestellung gelöscht',
    orderCount: 'Bestellung',
    todayDate: 'Heutiges Datum',
    
    // Products
    productName: 'Produktname',
    breadsPerBox: 'Brote pro Kiste',
    defaultPrice: 'Verkaufspreis',
    costPrice: 'Einkaufspreis',
    profit: 'Gewinn',
    addProduct: 'Produkt hinzufügen',
    editProduct: 'Produkt bearbeiten',
    bigBox: 'Große Kiste',
    smallBread: 'Kleines Brot',
    brownBread: 'Vollkornbrot',
    noProducts: 'Keine Produkte',
    productAdded: 'Produkt hinzugefügt',
    productUpdated: 'Produkt aktualisiert',
    productDeleted: 'Produkt gelöscht',
    productCount: 'Produkt',
    
    // Delivery
    deliverySheet: 'Lieferschein',
    totalBoxes: 'Gesamtkisten',
    boxesToReturn: 'Kisten zur Rückgabe',
    boxesReturned: 'Zurückgegebene Kisten',
    noDeliveries: 'Keine Lieferungen',
    printDelivery: 'Lieferschein drucken',
    deliveryCount: 'Lieferung',
    updateBoxes: 'Kisten aktualisieren',
    boxesUpdated: 'Kisten aktualisiert',
    returnedBoxes: 'Zurückgegebene Kisten',
    expectedBoxes: 'Erwartete Kisten',
    difference: 'Differenz',
    
    // Reports
    weeklyReport: 'Wochenbericht',
    fromDate: 'Von',
    toDate: 'Bis',
    thisWeek: 'Diese Woche',
    lastWeek: 'Letzte Woche',
    generateReport: 'Bericht erstellen',
    totalSales: 'Gesamtumsatz',
    totalExpenses: 'Gesamtausgaben',
    netProfit: 'Nettogewinn',
    remaining: 'Verbleibend',
    paid: 'Bezahlt',
    selectPeriod: 'Zeitraum auswählen',
    reportGenerated: 'Bericht erstellt',
    exportCSV: 'CSV exportieren',
    customerDetails: 'Kundendetails',
    
    // Expenses
    expenseCategory: 'Ausgabenkategorie',
    amount: 'Betrag',
    diesel: 'Diesel',
    maintenance: 'Wartung',
    salary: 'Gehalt',
    other: 'Sonstiges',
    addExpense: 'Ausgabe hinzufügen',
    editExpense: 'Ausgabe bearbeiten',
    noExpenses: 'Keine Ausgaben',
    expenseAdded: 'Ausgabe hinzugefügt',
    expenseDeleted: 'Ausgabe gelöscht',
    expenseCount: 'Ausgabe',
    description: 'Beschreibung',
    
    // Drivers
    driverName: 'Fahrername',
    addDriver: 'Fahrer hinzufügen',
    noDrivers: 'Keine Fahrer',
    driverAdded: 'Fahrer hinzugefügt',
    driverDeleted: 'Fahrer gelöscht',
    driverPassword: 'Fahrer-Passwort',
    driverCount: 'Fahrer',
    
    // Settings
    companyInfo: 'Firmeninfo',
    companyName: 'Firmenname',
    ownerName: 'Inhabername',
    taxNumber: 'Steuernummer',
    logo: 'Logo',
    bakeryManagement: 'Bäckereiverwaltung',
    addBakery: 'Bäckerei hinzufügen',
    superAdminNote: 'Sie sind Hauptadministrator',
    settingsSaved: 'Einstellungen gespeichert',
    uploadLogo: 'Logo hochladen',
    logoHint: 'Max 500KB - Quadratisch bevorzugt',
    bakeryAdded: 'Bäckerei hinzugefügt',
    bakeryDeleted: 'Bäckerei gelöscht',
    copyCredentials: 'Zugangsdaten kopieren',
    credentialsCopied: 'Kopiert',
    noBakeries: 'Keine Bäckereien',
    
    // Payments
    addPayment: 'Zahlung hinzufügen',
    paymentType: 'Zahlungsart',
    fullPayment: 'Vollzahlung',
    partialPayment: 'Teilzahlung',
    credit: 'Kredit',
    paymentAdded: 'Zahlung hinzugefügt',
    paymentDeleted: 'Zahlung gelöscht',
    editPayment: 'Zahlung bearbeiten',
    paymentUpdated: 'Zahlung aktualisiert',
    deletePaymentConfirm: 'Möchten Sie diese Zahlung löschen?',
    
    // Production
    production: 'Produktion',
    dailyProduction: 'Tagesproduktion',
    productionQuantity: 'Produktionsmenge',
    produced: 'Produziert',
    saveProduction: 'Produktion speichern',
    productionSaved: 'Produktionsmenge gespeichert',
    noProducts: 'Keine Produkte',
    productionReport: 'Produktionsbericht',
    productionSummaryTitle: 'Produktionsübersicht',
    dailyProductionDetail: 'Tägliche Produktionsdetails',
    customerSalesReport: 'Verkäufe, Lieferungen und Beträge pro Kunde',
    totalSales: 'Gesamtverkäufe',
    totalReceived: 'Gesamt erhalten',
    totalOutstanding: 'Ausstehende Beträge',
    sold: 'Verkauft',
    remaining: 'Verbleibend',
    outstanding: 'Ausstehend',
    paid: 'Bezahlt',
    delivered: 'Geliefert',
    pending: 'Ausstehend',
    todaySales: 'Heutige Verkäufe',
    deliveryStatus: 'Lieferstatus',
    financialSummary: 'Finanzübersicht',
    todayPayments: 'Heutige Zahlungen',
    noProductionToday: 'Heute keine Produktion erfasst',
    customersCount: 'Kundenanzahl',
    bundle: 'Bündel',
    bundles: 'Bündel',
    bundlesSold: 'Bündel verkauft',
    totalSold: 'Gesamt verkauft',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    monthlyReport: 'Monatsbericht',
    
    // Statement
    copyAsImage: 'Als Bild kopieren',
    imageCopied: 'Bild kopiert',
    statementPeriod: 'Auszugszeitraum',
    ordersSummary: 'Bestellungsübersicht',
    paymentsSummary: 'Zahlungsübersicht',
    accountStatement: 'Kontoauszug',
    backToCustomers: 'Zurück zu Kunden',
    backButton: 'Zurück',
    dataNotFound: 'Keine Daten gefunden',
    from: 'Von',
    to: 'Bis',
    previousBalance: 'Vorheriger Saldo',
    before: 'vor',
    ordersTitle: 'Bestellungen',
    dateColumn: 'Datum',
    dayColumn: 'Tag',
    productsColumn: 'Produkte',
    amountColumn: 'Betrag',
    taxColumn: 'Steuer',
    totalColumn: 'Gesamt',
    totalBoxes: 'Gesamtkisten',
    paymentsTitle: 'Zahlungen',
    typeColumn: 'Art',
    notesColumn: 'Notizen',
    totalSalesLabel: 'Gesamtumsatz',
    taxLabel: 'Steuer',
    paidLabel: 'Bezahlt',
    remainingBalance: 'Restbetrag',
    statementCreated: 'Erstellt am',
    copyImageSuccess: 'Bild kopiert - Zum Einfügen bereit',
    imageDownloaded: 'Bild heruntergeladen',
    copyImageError: 'Fehler beim Kopieren',
    phoneLabel: 'Telefon',
    taxNumberLabel: 'Steuernummer',
    bakery: 'Bäckerei',
    
    // Days
    sunday: 'Sonntag',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    
    // Driver Page
    driverView: 'Fahreransicht',
    driverWelcome: 'Willkommen',
    todayDeliveries: 'Heutige Lieferungen',
    selectDate: 'Datum wählen',
    refreshList: 'Liste aktualisieren',
    markDelivered: 'Geliefert',
    enterBoxesReturned: 'Zurückgegebene Kisten eingeben',
    boxesExpected: 'Erwartete Anzahl',
    confirmBoxes: 'Bestätigen',
    deliveryNotes: 'Liefernotizen',
    customerAddress: 'Kundenadresse',
    itemsToDeliver: 'Zu liefernde Artikel',
    
    // Errors
    loadError: 'Fehler beim Laden',
    saveError: 'Fehler beim Speichern',
    deleteError: 'Fehler beim Löschen',
    networkError: 'Verbindungsfehler',
    tryAgain: 'Erneut versuchen',
  },
  
  en: {
    // General
    appName: 'Bakery Manager',
    login: 'Login',
    logout: 'Logout',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No data',
    error: 'Error occurred',
    success: 'Success',
    confirm: 'Confirm',
    print: 'Print',
    export: 'Export',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    details: 'Details',
    total: 'Total',
    currency: '€',
    
    // Navigation
    dashboard: 'Dashboard',
    customers: 'Customers',
    orders: 'Orders',
    products: 'Products',
    delivery: 'Delivery Sheet',
    reports: 'Reports',
    expenses: 'Expenses',
    drivers: 'Drivers',
    settings: 'Settings',
    more: 'More',
    staffUsers: 'User Management',
    attendanceReport: 'Attendance Report',
    financialDues: 'Financial Dues',
    financials: 'Finance',
    financialsDesc: 'Manage dues and expenses',
    profitReport: 'Profit Report',
    employees: 'Employees',
    withdrawals: 'Withdrawals',
    whatsappMessages: 'WhatsApp Messages',
    germanInvoices: 'German Invoices',
    invoices: 'Old Invoices',
    deliveryProofs: 'Delivery Proofs',
    
    // Login Page
    loginTitle: 'Login',
    username: 'Username',
    password: 'Password',
    enterUsername: 'Enter username',
    enterPassword: 'Enter password',
    loginButton: 'Login',
    freeTrial: 'Free Trial!',
    freeTrialDesc: 'Login free for one day trial',
    noAccount: 'No account?',
    contactAdmin: 'Contact admin for credentials',
    contactViaWhatsapp: 'Contact via WhatsApp',
    dataSecure: 'All data is confidential and protected',
    wrongCredentials: 'Wrong username or password',
    
    // Dashboard
    todayOrders: 'Today Orders',
    todayRevenue: 'Today Revenue',
    totalCustomers: 'Total Customers',
    weeklyOrders: 'Weekly Orders',
    totalRevenue: 'Total Revenue',
    pendingDelivery: 'Pending Delivery',
    welcome: 'Welcome',
    dashboardDesc: 'Overview of your bakery',
    recentOrders: 'Recent Orders',
    topCustomers: 'Top Customers',
    
    // Customers
    customerName: 'Customer Name',
    shopName: 'Shop Name',
    phone: 'Phone',
    address: 'Address',
    area: 'Area',
    deliveryOrder: 'Delivery Order',
    totalDebt: 'Total Debt',
    totalPaid: 'Total Paid',
    balance: 'Balance',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    customerPrices: 'Customer Prices',
    taxRate: 'Tax Rate',
    customerStatement: 'Statement',
    noCustomers: 'No customers',
    addFirstCustomer: 'Add your first customer',
    searchCustomers: 'Search customers...',
    customerCount: 'customer',
    deleteCustomerConfirm: 'Delete this customer?',
    customerDeleted: 'Customer deleted',
    customerAdded: 'Customer added',
    customerUpdated: 'Customer updated',
    deliveryOrderHint: 'Delivery order number',
    noSearchResults: 'No results found',
    paymentType: 'Payment Type',
    fullPayment: 'Full Payment',
    partialPayment: 'Partial Payment',
    optionalNotes: 'Optional notes...',
    loadError: 'Error loading data',
    saveError: 'Error saving',
    deleteError: 'Error deleting',
    deleteCustomerWarning: 'Customer and all data will be deleted',
    pricingType: 'Pricing Type',
    byBox: 'By Box',
    byPiece: 'By Piece',
    totalPieces: 'Total Pieces',
    
    // Orders
    date: 'Date',
    day: 'Day',
    quantity: 'Quantity',
    price: 'Price',
    notes: 'Notes',
    addOrder: 'Add Order',
    editOrder: 'Edit Order',
    selectCustomer: 'Select Customer',
    noOrders: 'No orders',
    noOrdersForDate: 'No orders for this day',
    orderAdded: 'Order added',
    orderUpdated: 'Order updated',
    orderDeleted: 'Order deleted',
    orderCount: 'order',
    todayDate: 'Today',
    
    // Products
    productName: 'Product Name',
    breadsPerBox: 'Breads per Box',
    defaultPrice: 'Selling Price',
    costPrice: 'Cost Price',
    profit: 'Profit',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    bigBox: 'Big Box',
    smallBread: 'Small Bread',
    brownBread: 'Brown Bread',
    noProducts: 'No products',
    productAdded: 'Product added',
    productUpdated: 'Product updated',
    productDeleted: 'Product deleted',
    productCount: 'product',
    
    // Delivery
    deliverySheet: 'Delivery Sheet',
    totalBoxes: 'Total Boxes',
    boxesToReturn: 'Boxes to Return',
    boxesReturned: 'Boxes Returned',
    noDeliveries: 'No deliveries',
    printDelivery: 'Print Sheet',
    deliveryCount: 'delivery',
    updateBoxes: 'Update Boxes',
    boxesUpdated: 'Boxes updated',
    returnedBoxes: 'Returned Boxes',
    expectedBoxes: 'Expected Boxes',
    difference: 'Difference',
    
    // Reports
    weeklyReport: 'Weekly Report',
    fromDate: 'From',
    toDate: 'To',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    generateReport: 'Generate Report',
    totalSales: 'Total Sales',
    totalExpenses: 'Total Expenses',
    netProfit: 'Net Profit',
    remaining: 'Remaining',
    paid: 'Paid',
    selectPeriod: 'Select period',
    reportGenerated: 'Report generated',
    exportCSV: 'Export CSV',
    customerDetails: 'Customer Details',
    
    // Expenses
    expenseCategory: 'Category',
    amount: 'Amount',
    diesel: 'Diesel',
    maintenance: 'Maintenance',
    salary: 'Salary',
    other: 'Other',
    addExpense: 'Add Expense',
    editExpense: 'Edit Expense',
    noExpenses: 'No expenses',
    expenseAdded: 'Expense added',
    expenseDeleted: 'Expense deleted',
    expenseCount: 'expense',
    description: 'Description',
    
    // Drivers
    driverName: 'Driver Name',
    addDriver: 'Add Driver',
    noDrivers: 'No drivers',
    driverAdded: 'Driver added',
    driverDeleted: 'Driver deleted',
    driverPassword: 'Driver Password',
    driverCount: 'driver',
    
    // Settings
    companyInfo: 'Company Info',
    companyName: 'Company Name',
    ownerName: 'Owner Name',
    taxNumber: 'Tax Number',
    logo: 'Logo',
    bakeryManagement: 'Bakery Management',
    addBakery: 'Add Bakery',
    superAdminNote: 'You are the main admin',
    settingsSaved: 'Settings saved',
    uploadLogo: 'Upload Logo',
    logoHint: 'Max 500KB - Square preferred',
    bakeryAdded: 'Bakery added',
    bakeryDeleted: 'Bakery deleted',
    copyCredentials: 'Copy credentials',
    credentialsCopied: 'Copied',
    noBakeries: 'No bakeries',
    
    // Payments
    addPayment: 'Add Payment',
    paymentType: 'Payment Type',
    fullPayment: 'Full Payment',
    partialPayment: 'Partial Payment',
    credit: 'Credit',
    paymentAdded: 'Payment added',
    paymentDeleted: 'Payment deleted',
    editPayment: 'Edit Payment',
    paymentUpdated: 'Payment updated',
    deletePaymentConfirm: 'Do you want to delete this payment?',
    
    // Production
    production: 'Production',
    dailyProduction: 'Daily Production',
    productionQuantity: 'Production Quantity',
    produced: 'Produced',
    saveProduction: 'Save Production',
    productionSaved: 'Production saved',
    noProducts: 'No products',
    productionReport: 'Production Report',
    productionSummaryTitle: 'Production Summary',
    dailyProductionDetail: 'Daily Production Details',
    customerSalesReport: 'Sales, Deliveries & Balances by Customer',
    totalSales: 'Total Sales',
    totalReceived: 'Total Received',
    totalOutstanding: 'Outstanding Amounts',
    sold: 'Sold',
    remaining: 'Remaining',
    outstanding: 'Outstanding',
    paid: 'Paid',
    delivered: 'Delivered',
    pending: 'Pending',
    todaySales: 'Today Sales',
    deliveryStatus: 'Delivery Status',
    financialSummary: 'Financial Summary',
    todayPayments: 'Today Payments',
    noProductionToday: 'No production recorded today',
    customersCount: 'Customers Count',
    bundle: 'bundle',
    bundles: 'bundles',
    bundlesSold: 'Bundles sold',
    totalSold: 'Total sold',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    monthlyReport: 'Monthly Report',
    
    // Statement
    copyAsImage: 'Copy as Image',
    imageCopied: 'Image copied',
    statementPeriod: 'Statement Period',
    ordersSummary: 'Orders Summary',
    paymentsSummary: 'Payments Summary',
    accountStatement: 'Account Statement',
    backToCustomers: 'Back to Customers',
    backButton: 'Back',
    dataNotFound: 'Data not found',
    from: 'From',
    to: 'To',
    previousBalance: 'Previous Balance',
    before: 'before',
    ordersTitle: 'Orders',
    dateColumn: 'Date',
    dayColumn: 'Day',
    productsColumn: 'Products',
    amountColumn: 'Amount',
    taxColumn: 'Tax',
    totalColumn: 'Total',
    totalBoxes: 'Total Boxes',
    paymentsTitle: 'Payments',
    typeColumn: 'Type',
    notesColumn: 'Notes',
    totalSalesLabel: 'Total Sales',
    taxLabel: 'Tax',
    paidLabel: 'Paid',
    remainingBalance: 'Remaining Balance',
    statementCreated: 'Statement created on',
    copyImageSuccess: 'Image copied - Ready to paste',
    imageDownloaded: 'Image downloaded',
    copyImageError: 'Error copying image',
    phoneLabel: 'Phone',
    taxNumberLabel: 'Tax Number',
    bakery: 'Bakery',
    
    // Days
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    
    // Driver Page
    driverView: 'Driver View',
    driverWelcome: 'Welcome',
    todayDeliveries: 'Today Deliveries',
    selectDate: 'Select Date',
    refreshList: 'Refresh List',
    markDelivered: 'Delivered',
    enterBoxesReturned: 'Enter returned boxes',
    boxesExpected: 'Expected',
    confirmBoxes: 'Confirm',
    deliveryNotes: 'Delivery Notes',
    customerAddress: 'Customer Address',
    itemsToDeliver: 'Items to Deliver',
    
    // Errors
    loadError: 'Error loading data',
    saveError: 'Error saving data',
    deleteError: 'Error deleting',
    networkError: 'Network error',
    tryAgain: 'Try again',
  },
  
  tr: {
    // General
    appName: 'Fırın Yöneticisi',
    login: 'Giriş',
    logout: 'Çıkış',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    add: 'Ekle',
    search: 'Ara',
    loading: 'Yükleniyor...',
    noData: 'Veri yok',
    error: 'Hata oluştu',
    success: 'Başarılı',
    confirm: 'Onayla',
    print: 'Yazdır',
    export: 'Dışa Aktar',
    close: 'Kapat',
    yes: 'Evet',
    no: 'Hayır',
    actions: 'İşlemler',
    details: 'Detaylar',
    total: 'Toplam',
    currency: '€',
    
    // Navigation
    dashboard: 'Gösterge Paneli',
    customers: 'Müşteriler',
    orders: 'Siparişler',
    products: 'Ürünler',
    delivery: 'Teslimat Listesi',
    reports: 'Raporlar',
    expenses: 'Giderler',
    drivers: 'Sürücüler',
    settings: 'Ayarlar',
    more: 'Daha Fazla',
    staffUsers: 'Kullanıcı Yönetimi',
    attendanceReport: 'Devam Raporu',
    financialDues: 'Mali Alacaklar',
    financials: 'Finans',
    financialsDesc: 'Alacak ve giderleri yönet',
    profitReport: 'Kâr Raporu',
    employees: 'Çalışanlar',
    withdrawals: 'Para Çekme',
    whatsappMessages: 'WhatsApp Mesajları',
    germanInvoices: 'Alman Faturaları',
    invoices: 'Eski Faturalar',
    deliveryProofs: 'Teslimat Kanıtı',
    
    // Login Page
    loginTitle: 'Giriş Yap',
    username: 'Kullanıcı adı',
    password: 'Şifre',
    enterUsername: 'Kullanıcı adını girin',
    enterPassword: 'Şifreyi girin',
    loginButton: 'Giriş',
    freeTrial: 'Ücretsiz Deneme!',
    freeTrialDesc: 'Bir gün ücretsiz deneme',
    noAccount: 'Hesabınız yok mu?',
    contactAdmin: 'Yöneticiyle iletişime geçin',
    contactViaWhatsapp: 'WhatsApp ile iletişim',
    dataSecure: 'Tüm veriler gizli ve korumalıdır',
    wrongCredentials: 'Yanlış kullanıcı adı veya şifre',
    
    // Dashboard
    todayOrders: 'Bugünkü Siparişler',
    todayRevenue: 'Bugünkü Gelir',
    totalCustomers: 'Toplam Müşteri',
    weeklyOrders: 'Haftalık Siparişler',
    totalRevenue: 'Toplam Gelir',
    pendingDelivery: 'Bekleyen Teslimat',
    welcome: 'Hoş geldiniz',
    dashboardDesc: 'Fırınınıza genel bakış',
    recentOrders: 'Son Siparişler',
    topCustomers: 'En İyi Müşteriler',
    
    // Customers
    customerName: 'Müşteri Adı',
    shopName: 'Dükkan Adı',
    phone: 'Telefon',
    address: 'Adres',
    area: 'Bölge',
    deliveryOrder: 'Teslimat Sırası',
    totalDebt: 'Toplam Borç',
    totalPaid: 'Toplam Ödenen',
    balance: 'Kalan Bakiye',
    addCustomer: 'Müşteri Ekle',
    editCustomer: 'Müşteri Düzenle',
    customerPrices: 'Müşteri Fiyatları',
    taxRate: 'Vergi Oranı',
    customerStatement: 'Hesap Özeti',
    noCustomers: 'Müşteri yok',
    addFirstCustomer: 'İlk müşteriyi ekleyin',
    searchCustomers: 'Müşteri ara...',
    customerCount: 'müşteri',
    deleteCustomerConfirm: 'Müşteriyi silmek istiyor musunuz?',
    customerDeleted: 'Müşteri silindi',
    customerAdded: 'Müşteri eklendi',
    customerUpdated: 'Müşteri güncellendi',
    deliveryOrderHint: 'Teslimat sırası numarası',
    
    // Orders
    date: 'Tarih',
    day: 'Gün',
    quantity: 'Miktar',
    price: 'Fiyat',
    notes: 'Notlar',
    addOrder: 'Sipariş Ekle',
    editOrder: 'Sipariş Düzenle',
    selectCustomer: 'Müşteri Seç',
    noOrders: 'Sipariş yok',
    noOrdersForDate: 'Bu gün için sipariş yok',
    orderAdded: 'Sipariş eklendi',
    orderUpdated: 'Sipariş güncellendi',
    orderDeleted: 'Sipariş silindi',
    orderCount: 'sipariş',
    todayDate: 'Bugün',
    
    // Products
    productName: 'Ürün Adı',
    breadsPerBox: 'Kutu Başına Ekmek',
    defaultPrice: 'Satış Fiyatı',
    costPrice: 'Maliyet Fiyatı',
    profit: 'Kar',
    addProduct: 'Ürün Ekle',
    editProduct: 'Ürün Düzenle',
    bigBox: 'Büyük Kutu',
    smallBread: 'Küçük Ekmek',
    brownBread: 'Esmer Ekmek',
    noProducts: 'Ürün yok',
    productAdded: 'Ürün eklendi',
    productUpdated: 'Ürün güncellendi',
    productDeleted: 'Ürün silindi',
    productCount: 'ürün',
    
    // Delivery
    deliverySheet: 'Teslimat Listesi',
    totalBoxes: 'Toplam Kutu',
    boxesToReturn: 'İade Edilecek',
    boxesReturned: 'İade Edilen',
    noDeliveries: 'Teslimat yok',
    printDelivery: 'Listeyi Yazdır',
    deliveryCount: 'teslimat',
    updateBoxes: 'Kutuları Güncelle',
    boxesUpdated: 'Kutular güncellendi',
    returnedBoxes: 'İade Edilen Kutular',
    expectedBoxes: 'Beklenen Kutular',
    difference: 'Fark',
    
    // Reports
    weeklyReport: 'Haftalık Rapor',
    fromDate: 'Başlangıç',
    toDate: 'Bitiş',
    thisWeek: 'Bu Hafta',
    lastWeek: 'Geçen Hafta',
    generateReport: 'Rapor Oluştur',
    totalSales: 'Toplam Satış',
    totalExpenses: 'Toplam Gider',
    netProfit: 'Net Kar',
    remaining: 'Kalan',
    paid: 'Ödenen',
    selectPeriod: 'Dönem seçin',
    reportGenerated: 'Rapor oluşturuldu',
    exportCSV: 'CSV İndir',
    customerDetails: 'Müşteri Detayları',
    
    // Expenses
    expenseCategory: 'Gider Kategorisi',
    amount: 'Tutar',
    diesel: 'Dizel',
    maintenance: 'Bakım',
    salary: 'Maaş',
    other: 'Diğer',
    addExpense: 'Gider Ekle',
    editExpense: 'Gider Düzenle',
    noExpenses: 'Gider yok',
    expenseAdded: 'Gider eklendi',
    expenseDeleted: 'Gider silindi',
    expenseCount: 'gider',
    description: 'Açıklama',
    
    // Drivers
    driverName: 'Sürücü Adı',
    addDriver: 'Sürücü Ekle',
    noDrivers: 'Sürücü yok',
    driverAdded: 'Sürücü eklendi',
    driverDeleted: 'Sürücü silindi',
    driverPassword: 'Sürücü Şifresi',
    driverCount: 'sürücü',
    
    // Settings
    companyInfo: 'Şirket Bilgileri',
    companyName: 'Şirket Adı',
    ownerName: 'Sahip Adı',
    taxNumber: 'Vergi Numarası',
    logo: 'Logo',
    bakeryManagement: 'Fırın Yönetimi',
    addBakery: 'Fırın Ekle',
    superAdminNote: 'Ana yöneticisiniz',
    settingsSaved: 'Ayarlar kaydedildi',
    uploadLogo: 'Logo Yükle',
    logoHint: 'Max 500KB - Kare tercih edilir',
    bakeryAdded: 'Fırın eklendi',
    bakeryDeleted: 'Fırın silindi',
    copyCredentials: 'Bilgileri kopyala',
    credentialsCopied: 'Kopyalandı',
    noBakeries: 'Fırın yok',
    
    // Payments
    addPayment: 'Ödeme Ekle',
    paymentType: 'Ödeme Türü',
    fullPayment: 'Tam Ödeme',
    partialPayment: 'Kısmi Ödeme',
    credit: 'Kredi',
    paymentAdded: 'Ödeme eklendi',
    paymentDeleted: 'Ödeme silindi',
    editPayment: 'Ödeme Düzenle',
    paymentUpdated: 'Ödeme güncellendi',
    deletePaymentConfirm: 'Bu ödemeyi silmek istiyor musunuz?',
    
    // Production
    production: 'Üretim',
    dailyProduction: 'Günlük Üretim',
    productionQuantity: 'Üretim Miktarı',
    produced: 'Üretildi',
    saveProduction: 'Üretimi Kaydet',
    productionSaved: 'Üretim miktarı kaydedildi',
    noProducts: 'Ürün yok',
    productionReport: 'Üretim Raporu',
    productionSummaryTitle: 'Üretim Özeti',
    dailyProductionDetail: 'Günlük Üretim Detayları',
    customerSalesReport: 'Müşteri Bazında Satışlar, Teslimatlar ve Bakiyeler',
    totalSales: 'Toplam Satışlar',
    totalReceived: 'Toplam Alınan',
    totalOutstanding: 'Ödenmemiş Tutarlar',
    sold: 'Satılan',
    remaining: 'Kalan',
    outstanding: 'Ödenmemiş',
    paid: 'Ödendi',
    delivered: 'Teslim Edildi',
    pending: 'Beklemede',
    todaySales: 'Bugünkü Satışlar',
    deliveryStatus: 'Teslimat Durumu',
    financialSummary: 'Mali Özet',
    todayPayments: 'Bugünkü Ödemeler',
    noProductionToday: 'Bugün üretim kaydedilmedi',
    customersCount: 'Müşteri Sayısı',
    bundle: 'demet',
    bundles: 'demetler',
    bundlesSold: 'Satılan demet',
    totalSold: 'Toplam satılan',
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    monthlyReport: 'Aylık Rapor',
    
    // Statement
    copyAsImage: 'Resim Olarak Kopyala',
    imageCopied: 'Resim kopyalandı',
    statementPeriod: 'Dönem',
    ordersSummary: 'Sipariş Özeti',
    paymentsSummary: 'Ödeme Özeti',
    accountStatement: 'Hesap Özeti',
    backToCustomers: 'Müşterilere Dön',
    backButton: 'Geri',
    dataNotFound: 'Veri bulunamadı',
    from: 'Başlangıç',
    to: 'Bitiş',
    previousBalance: 'Önceki Bakiye',
    before: 'öncesi',
    ordersTitle: 'Siparişler',
    dateColumn: 'Tarih',
    dayColumn: 'Gün',
    productsColumn: 'Ürünler',
    amountColumn: 'Tutar',
    taxColumn: 'Vergi',
    totalColumn: 'Toplam',
    totalBoxes: 'Toplam Kutu',
    paymentsTitle: 'Ödemeler',
    typeColumn: 'Tür',
    notesColumn: 'Notlar',
    totalSalesLabel: 'Toplam Satış',
    taxLabel: 'Vergi',
    paidLabel: 'Ödenen',
    remainingBalance: 'Kalan Bakiye',
    statementCreated: 'Oluşturulma tarihi',
    copyImageSuccess: 'Resim kopyalandı - Yapıştırmaya hazır',
    imageDownloaded: 'Resim indirildi',
    copyImageError: 'Kopyalama hatası',
    phoneLabel: 'Telefon',
    taxNumberLabel: 'Vergi No',
    bakery: 'Fırın',
    
    // Days
    sunday: 'Pazar',
    monday: 'Pazartesi',
    tuesday: 'Salı',
    wednesday: 'Çarşamba',
    thursday: 'Perşembe',
    friday: 'Cuma',
    saturday: 'Cumartesi',
    
    // Driver Page
    driverView: 'Sürücü Görünümü',
    driverWelcome: 'Hoş geldiniz',
    todayDeliveries: 'Bugünkü Teslimatlar',
    selectDate: 'Tarih Seç',
    refreshList: 'Listeyi Yenile',
    markDelivered: 'Teslim Edildi',
    enterBoxesReturned: 'İade edilen kutu sayısı',
    boxesExpected: 'Beklenen',
    confirmBoxes: 'Onayla',
    deliveryNotes: 'Teslimat Notları',
    customerAddress: 'Müşteri Adresi',
    itemsToDeliver: 'Teslim Edilecekler',
    
    // Errors
    loadError: 'Yükleme hatası',
    saveError: 'Kaydetme hatası',
    deleteError: 'Silme hatası',
    networkError: 'Bağlantı hatası',
    tryAgain: 'Tekrar dene',
  },
  
  ku: {
    // General (Kurdish - Kurmanji)
    appName: 'Rêvebirê Nanpêj',
    login: 'Têketin',
    logout: 'Derketin',
    save: 'Tomar bike',
    cancel: 'Betal bike',
    delete: 'Jê bibe',
    edit: 'Biguherîne',
    add: 'Lê zêde bike',
    search: 'Bigere',
    loading: 'Tê barkirin...',
    noData: 'Dane tune',
    error: 'Çewtî çêbû',
    success: 'Serketî',
    confirm: 'Piştrast bike',
    print: 'Çap bike',
    export: 'Derxîne',
    close: 'Bigire',
    yes: 'Erê',
    no: 'Na',
    actions: 'Kiryar',
    details: 'Hûragahî',
    total: 'Giştî',
    currency: '€',
    
    // Navigation
    dashboard: 'Panela Sereke',
    customers: 'Xerîdar',
    orders: 'Spartin',
    products: 'Hilber',
    delivery: 'Lîsteya Radestkirinê',
    reports: 'Rapor',
    expenses: 'Mesref',
    drivers: 'Şofêr',
    settings: 'Mîheng',
    more: 'Zêdetir',
    staffUsers: 'Rêveberiya Bikarhêneran',
    attendanceReport: 'Rapora Amadekariyê',
    financialDues: 'Deynên Darayî',
    financials: 'Darayî',
    financialsDesc: 'Birêvebirina deyn û lêçûnan',
    profitReport: 'Rapora Qezencê',
    employees: 'Karmend',
    withdrawals: 'Vekişandin',
    whatsappMessages: 'Peyamên WhatsApp',
    germanInvoices: 'Faturayên Almanî',
    invoices: 'Faturayên Kevin',
    deliveryProofs: 'Belgeya Radestkirinê',
    
    // Login Page
    loginTitle: 'Têketin',
    username: 'Navê bikarhêner',
    password: 'Şîfre',
    enterUsername: 'Navê bikarhêner binivîse',
    enterPassword: 'Şîfre binivîse',
    loginButton: 'Têkeve',
    freeTrial: 'Ceribandina Belaş!',
    freeTrialDesc: 'Têketina rojekê belaş e',
    noAccount: 'Hesabê te tune?',
    contactAdmin: 'Bi rêveberê re têkilî daynin',
    contactViaWhatsapp: 'Bi WhatsApp re têkilî daynin',
    dataSecure: 'Hemû dane nepenî û parastî ne',
    wrongCredentials: 'Nav an şîfre çewt e',
    
    // Dashboard
    todayOrders: 'Spartinên Îro',
    todayRevenue: 'Dahata Îro',
    totalCustomers: 'Hejmara Xerîdaran',
    weeklyOrders: 'Spartinên Heftane',
    totalRevenue: 'Dahata Giştî',
    pendingDelivery: 'Li benda radestkirinê',
    welcome: 'Bi xêr hatî',
    dashboardDesc: 'Dîmendera nanpêjê',
    recentOrders: 'Spartinên Dawî',
    topCustomers: 'Xerîdarên Baş',
    
    // Customers
    customerName: 'Navê Xerîdar',
    shopName: 'Navê Dikan',
    phone: 'Telefon',
    address: 'Navnîşan',
    area: 'Herêm',
    deliveryOrder: 'Rêza Radestkirinê',
    totalDebt: 'Deynê Giştî',
    totalPaid: 'Peredayîna Giştî',
    balance: 'Mayî',
    addCustomer: 'Xerîdar Zêde Bike',
    editCustomer: 'Xerîdar Biguherîne',
    customerPrices: 'Bihayên Xerîdar',
    taxRate: 'Rêjeya Bacê',
    customerStatement: 'Hesabê Xerîdar',
    noCustomers: 'Xerîdar tune',
    addFirstCustomer: 'Xerîdarê yekem zêde bike',
    searchCustomers: 'Xerîdar bigere...',
    customerCount: 'xerîdar',
    deleteCustomerConfirm: 'Xerîdar jê bibe?',
    customerDeleted: 'Xerîdar hat jêbirin',
    customerAdded: 'Xerîdar hat zêdekirin',
    customerUpdated: 'Xerîdar hat nûkirin',
    deliveryOrderHint: 'Hejmara rêza radestkirinê',
    
    // Orders
    date: 'Dîrok',
    day: 'Roj',
    quantity: 'Hejmar',
    price: 'Biha',
    notes: 'Têbînî',
    addOrder: 'Spartin Zêde Bike',
    editOrder: 'Spartin Biguherîne',
    selectCustomer: 'Xerîdar Hilbijêre',
    noOrders: 'Spartin tune',
    noOrdersForDate: 'Ji bo vê rojê spartin tune',
    orderAdded: 'Spartin hat zêdekirin',
    orderUpdated: 'Spartin hat nûkirin',
    orderDeleted: 'Spartin hat jêbirin',
    orderCount: 'spartin',
    todayDate: 'Îro',
    
    // Products
    productName: 'Navê Hilberê',
    breadsPerBox: 'Nan di Qutiyê de',
    defaultPrice: 'Bihayê Firotanê',
    costPrice: 'Bihayê Kirînê',
    profit: 'Qezenc',
    addProduct: 'Hilber Zêde Bike',
    editProduct: 'Hilber Biguherîne',
    bigBox: 'Qutiya Mezin',
    smallBread: 'Nanê Biçûk',
    brownBread: 'Nanê Qehweyî',
    noProducts: 'Hilber tune',
    productAdded: 'Hilber hat zêdekirin',
    productUpdated: 'Hilber hat nûkirin',
    productDeleted: 'Hilber hat jêbirin',
    productCount: 'hilber',
    
    // Delivery
    deliverySheet: 'Lîsteya Radestkirinê',
    totalBoxes: 'Qutiyên Giştî',
    boxesToReturn: 'Qutiyên Vegerandinê',
    boxesReturned: 'Qutiyên Vegerandî',
    noDeliveries: 'Radestkirina tune',
    printDelivery: 'Lîsteyê Çap Bike',
    deliveryCount: 'radest',
    updateBoxes: 'Qutiyan Nû Bike',
    boxesUpdated: 'Qutî hatin nûkirin',
    returnedBoxes: 'Qutiyên Vegerandî',
    expectedBoxes: 'Qutiyên Bendewar',
    difference: 'Ferq',
    
    // Reports
    weeklyReport: 'Rapora Heftane',
    fromDate: 'Ji',
    toDate: 'Heta',
    thisWeek: 'Ev Hefte',
    lastWeek: 'Hefteya Borî',
    generateReport: 'Rapor Çêke',
    totalSales: 'Firotana Giştî',
    totalExpenses: 'Mesrefên Giştî',
    netProfit: 'Qezenca Safî',
    remaining: 'Mayî',
    paid: 'Dayî',
    selectPeriod: 'Dem hilbijêre',
    reportGenerated: 'Rapor hat çêkirin',
    exportCSV: 'CSV daxîne',
    customerDetails: 'Hûragahiyên Xerîdar',
    
    // Expenses
    expenseCategory: 'Kategoriya Mesrefê',
    amount: 'Mîqdar',
    diesel: 'Mazot',
    maintenance: 'Tamîrkirin',
    salary: 'Mûçe',
    other: 'Yên Din',
    addExpense: 'Mesref Zêde Bike',
    editExpense: 'Mesref Biguherîne',
    noExpenses: 'Mesref tune',
    expenseAdded: 'Mesref hat zêdekirin',
    expenseDeleted: 'Mesref hat jêbirin',
    expenseCount: 'mesref',
    description: 'Ravekirin',
    
    // Drivers
    driverName: 'Navê Şofêr',
    addDriver: 'Şofêr Zêde Bike',
    noDrivers: 'Şofêr tune',
    driverAdded: 'Şofêr hat zêdekirin',
    driverDeleted: 'Şofêr hat jêbirin',
    driverPassword: 'Şîfreya Şofêr',
    driverCount: 'şofêr',
    
    // Settings
    companyInfo: 'Agahiyên Pargîdaniyê',
    companyName: 'Navê Pargîdaniyê',
    ownerName: 'Navê Xwedî',
    taxNumber: 'Hejmara Bacê',
    logo: 'Logo',
    bakeryManagement: 'Rêvebiriya Nanpêjan',
    addBakery: 'Nanpêj Zêde Bike',
    superAdminNote: 'Tu rêvebirê sereke yî',
    settingsSaved: 'Mîheng hatin tomarkirin',
    uploadLogo: 'Logo bar bike',
    logoHint: 'Herî zêde 500KB',
    bakeryAdded: 'Nanpêj hat zêdekirin',
    bakeryDeleted: 'Nanpêj hat jêbirin',
    copyCredentials: 'Agahiyan kopî bike',
    credentialsCopied: 'Hat kopîkirin',
    noBakeries: 'Nanpêj tune',
    
    // Payments
    addPayment: 'Dayîn Zêde Bike',
    paymentType: 'Cureyê Dayînê',
    fullPayment: 'Dayîna Temam',
    partialPayment: 'Dayîna Parçeyî',
    credit: 'Deyn',
    paymentAdded: 'Dayîn hat zêdekirin',
    paymentDeleted: 'Dayîn hat jêbirin',
    editPayment: 'Dayînê Biguherîne',
    paymentUpdated: 'Dayîn hat guhertin',
    deletePaymentConfirm: 'Tu dixwazî vê dayînê jê bibî?',
    
    // Production
    production: 'Hilberîn',
    dailyProduction: 'Hilberîna Rojane',
    productionQuantity: 'Mîqdara Hilberînê',
    produced: 'Hilberî',
    saveProduction: 'Hilberînê Tomar Bike',
    productionSaved: 'Mîqdara hilberînê hat tomarkirin',
    noProducts: 'Hilber tune',
    productionReport: 'Rapora Hilberînê',
    productionSummaryTitle: 'Kurteya Hilberînê',
    dailyProductionDetail: 'Hûrguliyên Hilberîna Rojane',
    customerSalesReport: 'Firot, Radest û Mêtinên Li Gor Xerîdar',
    totalSales: 'Giştî Firotin',
    totalReceived: 'Giştî Wergirtin',
    totalOutstanding: 'Mêtinên Nehatî Dayîn',
    sold: 'Hatiye Firotin',
    remaining: 'Dimîne',
    outstanding: 'Nehatî Dayîn',
    paid: 'Hatiye Dayîn',
    delivered: 'Hatiye Radest Kirin',
    pending: 'Li Bendê',
    todaySales: 'Firotina Îro',
    deliveryStatus: 'Rewşa Radestkirinê',
    financialSummary: 'Kurteya Darayî',
    todayPayments: 'Dayînên Îro',
    noProductionToday: 'Îro hilberîn nehat tomarkirin',
    customersCount: 'Jimara Xerîdaran',
    bundle: 'girêk',
    bundles: 'girêk',
    bundlesSold: 'Girêkên hatine firotin',
    totalSold: 'Giştî hatine firotin',
    daily: 'Rojane',
    weekly: 'Heftane',
    monthly: 'Mehane',
    monthlyReport: 'Rapora Mehane',
    
    // Statement
    copyAsImage: 'Wek Wêne Kopî Bike',
    imageCopied: 'Wêne hat kopîkirin',
    statementPeriod: 'Dema Hesabê',
    ordersSummary: 'Kurteya Spartinan',
    paymentsSummary: 'Kurteya Dayînan',
    accountStatement: 'Hesabê Xerîdar',
    backToCustomers: 'Vegere Xerîdaran',
    backButton: 'Vegere',
    dataNotFound: 'Dane nehate dîtin',
    from: 'Ji',
    to: 'Heta',
    previousBalance: 'Mayiya Berê',
    before: 'berî',
    ordersTitle: 'Spartin',
    dateColumn: 'Dîrok',
    dayColumn: 'Roj',
    productsColumn: 'Hilber',
    amountColumn: 'Mîqdar',
    taxColumn: 'Bac',
    totalColumn: 'Giştî',
    totalBoxes: 'Qutiyên Giştî',
    paymentsTitle: 'Dayîn',
    typeColumn: 'Cure',
    notesColumn: 'Têbînî',
    totalSalesLabel: 'Firotana Giştî',
    taxLabel: 'Bac',
    paidLabel: 'Hatiye Dayîn',
    remainingBalance: 'Mayiya Maye',
    statementCreated: 'Di vê dîrokê de hat çêkirin',
    copyImageSuccess: 'Wêne hat kopîkirin',
    imageDownloaded: 'Wêne hat daxistin',
    copyImageError: 'Çewtiya kopîkirinê',
    phoneLabel: 'Telefon',
    taxNumberLabel: 'Hejmara Bacê',
    bakery: 'Nanpêj',
    
    // Days
    sunday: 'Yekşem',
    monday: 'Duşem',
    tuesday: 'Sêşem',
    wednesday: 'Çarşem',
    thursday: 'Pêncşem',
    friday: 'În',
    saturday: 'Şemî',
    
    // Driver Page
    driverView: 'Dîmena Şofêr',
    driverWelcome: 'Bi xêr hatî',
    todayDeliveries: 'Radestkirinên Îro',
    selectDate: 'Dîrok Hilbijêre',
    refreshList: 'Lîsteyê Nû Bike',
    markDelivered: 'Hat Radeskirin',
    enterBoxesReturned: 'Hejmara qutiyên vegerandî',
    boxesExpected: 'Bendewar',
    confirmBoxes: 'Piştrast Bike',
    deliveryNotes: 'Têbîniyên Radestkirinê',
    customerAddress: 'Navnîşana Xerîdar',
    itemsToDeliver: 'Tiştên Radestkirinê',
    
    // Errors
    loadError: 'Çewtiya barkirinê',
    saveError: 'Çewtiya tomarkirinê',
    deleteError: 'Çewtiya jêbirinê',
    networkError: 'Çewtiya torê',
    tryAgain: 'Dîsa biceribîne',
  }
};

export const languageNames = {
  ar: 'العربية',
  de: 'Deutsch',
  en: 'English',
  tr: 'Türkçe',
  ku: 'Kurdî'
};

export const languageFlags = {
  ar: '🇸🇦',
  de: '🇩🇪',
  en: '🇬🇧',
  tr: '🇹🇷',
  ku: '🇮🇶'
};

export const rtlLanguages = ['ar', 'ku'];
